export default __webpack_public_path__ + "static/media/nunito.light.9d78cf05.ttf";